import { createIntegrationConnectionConfigurationClassMixin } from '../../../connection/configuration/IntegrationConnectionConfigurationMixin';

export interface ClubReadyClientConfigurationValid {
    type: 'VALID';
    chainIds: string[];
}

export interface ClubReadyClientConfigurationMissing {
    type: 'MISSING_CHAIN_ID';
}

export type ClubReadyClientConfigurationUnion = ClubReadyClientConfigurationMissing | ClubReadyClientConfigurationValid;

export class ClubReadyClientConfiguration extends createIntegrationConnectionConfigurationClassMixin<
    ClubReadyClientConfigurationUnion,
    'CLUB_READY_CLIENT'
>('CLUB_READY_CLIENT') {}
